module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAxElEQVRIie3RMQ+CMBCG4f4hJ01YiQMjE4u687cdcJLJYBxMzGsuKYKklKs0Tv2SW8rd9wyYlJRPgBq4A2cgA0ykka6L7a7loWPILRKW2a4+nTw2fGctNkUkjXzIgUckzIVId94v7CNgc4h0m/HiGmznQJ5A0e9MDwq7MMW2HmQDtA6kHO+5DksH1trCn5A5SIupER+0hAUhS5APC0I00BwWhGghH/YCDpoOLSRztMVj5KS9D4FkKuBq/1EVcpuS8ucYY94AThCq42FSRAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/family/index_home_arrow_down.png
// module id = lYsW
// module chunks = 1